export type PointerType = 'mouse' | 'touch' | 'both'

export const addClickListener = (elem: HTMLElement, callback: (e: MouseEvent, pointerType: PointerType) => void) => {
  let wasMoved = false
  let pointerType: PointerType

  const pointerDownHandler = (e: PointerEvent) => {
    wasMoved = false
    document.addEventListener('pointerup', pointerUpHandler)
    elem.addEventListener('pointermove', pointerMoveHandler)
  }

  const pointerMoveHandler = () => {
    wasMoved = true
  }

  const pointerUpHandler = (e: PointerEvent) => {
    pointerType = e.pointerType as PointerType
    elem.removeEventListener('pointermove', pointerMoveHandler)
    document.removeEventListener('pointerup', pointerUpHandler)
  }

  const clickHandler = (e: MouseEvent) => {
    if (wasMoved && pointerType !== 'touch') return
    callback(e, pointerType)
  }

  elem.addEventListener('pointerdown', pointerDownHandler)
  elem.addEventListener('click', clickHandler)
  return () => {
    elem.removeEventListener('pointerdown', pointerDownHandler)
    elem.removeEventListener('click', clickHandler)
  }
}
